import {lazy} from '@aboutyou/lazy-imports';

export const OutfitFlyout = lazy(() =>
  import('./OutfitFlyout.eager').then(mod => ({default: mod.OutfitFlyoutView})),
);
